export default {
    url: '/users',
    template: '<ui-view></ui-view>',
    abstract: true
};



// WEBPACK FOOTER //
// ./src/app/states/authorized/manage/permissions/users/index.js